<template>
  <div>
    <Header></Header>
    <router-view
      :key="$route.fullPath"
      style="min-height: 150px;"
    ></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./component/header";
import Footer from "./component/footer";

export default {
  name: "app",
  components: {
    Header,
    Footer
  }
  // metaInfo() {
  //   return {
  //     title: "Epiloge - Build your network in your field of interest",
  //     meta: [
  //       {
  //         name: "description",
  //         content:
  //           "Epiloge is about connecting in your field of interest. Our vision is to help people share their knowledge, work, projects, papers and ideas and build their network through what they do rather where they live, study or work."
  //       },
  //       {
  //         property: "og:title",
  //         content: "Epiloge - Build your network in your field of interest"
  //       },
  //       { property: "og:site_name", content: "Epiloge" },
  //       { property: "og:type", content: "website" },
  //       { name: "robots", content: "index,follow" }
  //     ]
  //   };
  // }
};
</script>
<style>
@import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
@import "/src/assets/animate.min.css";
</style>
<style>
body,
html {
  font-family: "Kanit", sans-serif;
  color: #000;
}
#nprogress .bar {
  background: #eb1c23;
  height: 3px;
}
#nprogress .spinner-icon {
  border-top-color: #eb1c23;
  border-left-color: #eb1c23;
}
.zoom img {
  cursor: crosshair;
}
h1 {
  margin-bottom: 20px;
}
.font-14 {
  font-size: 14px;
}
.max-width img {
  max-width: 100%;
}
.bg-black {
  background: #000;
}
.font-size-25 {
  font-size: 25px;
}
.font-m {
  font-size: 0.8rem;
}
.font-sm {
  font-size: 0.71rem;
}
.pre-wrap {
  white-space: pre-wrap;
}
.note:after {
  content: "";
  width: 75%;
  background: #000;
  height: 2px;
  position: relative;
  display: block;
  margin: 5px auto;
}
.form-control:focus {
  box-shadow: 0 0 0 1px rgba(4, 4, 4, 0.25);
  border-color: white;
}
input[type="text"] {
  width: 100%;
}
#product-detail h5 {
  height: 48px;
  overflow: hidden;
}
#product-detail p {
  height: 72px;
  overflow: hidden;
}
.color-70 {
  color: #707070;
}
.width-100 {
  width: 100%;
}
.item:hover .img-product img {
  max-width: 113%;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  opacity: 0.8;
}
@media screen and (min-width: 100px) and (max-width: 812px) {
  .grid-container {
    grid-template-columns: auto;
    grid-gap: 15px;
  }
}
#myCarousel {
  margin: 30px 0;
}
.grid-container--category {
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 30px;
}
#read-more a {
  background: #343a40;
  color: #fff;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  font-size: 14px;
}
.item:hover #read-more a {
  background: #eb1c23;
  color: #fff;
}
.item {
  border: 1px solid rgb(212, 210, 210);
  padding: 0 15px 15px 15px;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
}
.item:hover {
  border: 1px solid #111;
}
.img-product {
  height: 210px;
  overflow: hidden;
}
.grid-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  min-height: 452px;
}
.spinner-grow {
  margin-top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue